

import React, { useState, useEffect, useRef } from "react";

import {  
  Share2,
  MoreVertical,
  ArchiveRestore,
  X,
  LockKeyhole,
  Pencil,
  Lock,
  Calendar,
  FileText,
  UsersRound,
  ChartColumnIncreasing,
  TriangleAlert,
  Link2Icon,
  ThumbsUp,
  MessageSquare,
} from "lucide-react";


import {
  FaWhatsapp,
  FaFacebookF,
  FaLinkedinIn,
  FaXTwitter,
} from "react-icons/fa6";

import { MdOutlineMail } from "react-icons/md";
import { useNavigate } from "react-router-dom";


import survayimg1 from "../../assets/img/whatwedo.jpg";
import RedButton from "../RedButton";
import { toast } from 'react-toastify';
import { closeSurvey, archiveSurvey } from "../../service/mySurvey";
import { SurveyService } from "../../service/saveSurvey";
import MySurveyEngagementModal from "./MySurveyEngagementModal";
import MySurveyCommentsThread from "./MySurveyCommentsThread";


const ActiveSurveys = ({ surveys = [], loading, hasMore, onLoadMore, onRefresh, onSwitchTab }) => { 

    const [activeToggleMenu, setActiveToggleMenu] = useState(null);
    const [selectedSurvey, setSelectedSurvey] = useState(null);
    const [showCloseSurveyModal, setShowCloseSurveyModal] = useState(false);
    const [engagementModalTab, setEngagementModalTab] = useState("likes");
    const [showEngagementModal, setShowEngagementModal] = useState(false);

    const [expandedComments, setExpandedComments] = useState({});

    const toggleComments = (surveyId) => {
      setExpandedComments(prev => ({
        ...prev,
        [surveyId]: !prev[surveyId]
      }));
    };

    const [showShareModal, setShowShareModal] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const menuRef = useRef(null);

    const navigate = useNavigate();

    const formatDate = (dateString) => {
      if (!dateString) return "";
      return new Date(dateString).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    };

    useEffect(() => {
    const handleClickOutside = (event) => {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
        setActiveToggleMenu(null);
        }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
        document.removeEventListener("mousedown", handleClickOutside);
    };
    }, []);



    const handleArchive = async (surveyId, surveyTitle) => {
        if (submitting) return;
        try {
            setSubmitting(true);
            const response = await archiveSurvey(surveyId);
            if (response && response.data && response.data.success) {
                toast.success(
                  <div>
                    <div className="fw-bold">Survey Archived Successfully</div>
                    <div>{surveyTitle || "Survey"} has been moved to Archived Surveys.</div>
                    <button
                      type="button"
                      className="survey-toast-link bg-transparent p-0 mt-2"
                      onClick={() => onSwitchTab && onSwitchTab("archivedSurveys")}
                    >
                      View Archived Surveys
                    </button>
                  </div>
                );
                if (onSwitchTab) onSwitchTab("archivedSurveys");
                if (onRefresh) onRefresh();
            } else {
                toast.error(response.data.message || "Failed to archive survey");
            }
        } catch (error) {
            console.error("Error archiving survey:", error);
            toast.error("An error occurred while archiving the survey.");
        } finally {
            setSubmitting(false);
        }
    };


    const handleCloseSurvey = async () => {
        if (!selectedSurvey || submitting) return;
        try {
            setSubmitting(true);
            const response = await closeSurvey(selectedSurvey.id);
            if (response && response.data && response.data.success) {
                setShowCloseSurveyModal(false);
                toast.success(`${selectedSurvey.survey_title || "Survey"} has been moved to Closed Surveys.`);
                if (onSwitchTab) onSwitchTab("closedSurvey");
                if (onRefresh) onRefresh();
            } else {
                toast.error(response.data.message || "Failed to close survey");
            }
        } catch (error) {
            console.error("Error closing survey:", error);
            toast.error("An error occurred while closing the survey.");
        } finally {
            setSubmitting(false);
        }
    };



    const handleCopyLink = async () => {
        if (!selectedSurvey?.id) {
            toast.error("Survey link is not available.");
            return;
        }
        await navigator.clipboard.writeText(
            `${window.location.origin}/take-survey/${selectedSurvey.id}`
        );
        toast.success("Survey link copied to clipboard.");
    };


    const EditSurvey = async (surveyId) => {
        try {
            const response = await SurveyService.getSurveyPreview(surveyId);

            console.log("response Edit Survey ==========>", response);

            if (response.status === 200) {

                console.log("Before Navigate ==========>", {
                    survey: response.data,
                });

            navigate("/edit-survey/step-1", {
                state: {
                editData: response.data.data.survey,
                questions: response.data.data.questions,
                isEdit: true,
                previewData: response.data.data,
                },
            });
            }
        } catch (error) {
            console.error("Edit Survey Error:", error);
        }
    };
    
   
    return (
        <>

        {loading && surveys.length === 0 ? (
          <div className="d-flex justify-content-center my-4">
             <div className="spinner-border text-danger" role="status">
                <span className="visually-hidden">Loading...</span>
             </div>
          </div>
        ) : null}
       

        {surveys.map((item) => (
            <div className="sr-result-card mb-3" key={item.id}>            

                <div className="row g-3 align-items-center">
                    <div className="col-12 col-sm-auto">
                    <img src={survayimg1} alt={item.survey_title || "Survey"} className="rounded-4 border" style={{width: "70px", height: "64px", }} />
                    </div>

                    <div className="col-12 col-sm">
                <div className="d-flex align-items-center justify-content-between gap-3">
                    <div>
                        <h2 className="sr-result-title">{item.survey_title}</h2>
                        <p className="sr-result-copy mt-1">Last Response: {item.last_response_at || item.last_response_date ? formatDate(item.last_response_at || item.last_response_date) : Number(item.responses) > 0 ? "Date unavailable" : "No response yet"}</p>
                    </div>

                            <div className="d-flex gap-2 justify-content-md-end position-relative">

                            <div className="position-relative">                            
                                <div className={`user-status active`}>
                                    {/* <span className="status-dot"></span> */}
                                    <span>Active</span>
                                </div>
                            </div>

                            <button
                                type="button"
                                className="text-black border-0 bg-transparent"
                                onClick={() => setActiveToggleMenu(activeToggleMenu === item.id ? null : item.id)}
                            >
                                <MoreVertical size={20} />
                            </button>

                            {activeToggleMenu === item.id && (
                                <div className="cs-question-menu" ref={menuRef}>
                                <div className="d-flex gap-1 flex-column w-100">
                                        <button className="cs-action-link"  onClick={() => EditSurvey(item.id)}>
                                            <Pencil size={16} />
                                            <span>Edit</span>
                                        </button>

                                        <button className="cs-action-link" onClick={() => {
                                            setSelectedSurvey(item);
                                            setShowShareModal(true);
                                        }}>
                                            <Share2 size={16} />
                                            <span>Share</span>
                                        </button>

                                        <button className="cs-action-link" onClick={() => {
                                            setSelectedSurvey(item);
                                            setShowCloseSurveyModal(true);
                                        }}>
                                            <Lock size={16} />
                                            <span>Close</span>
                                        </button>

                                        <button className="cs-action-link" onClick={() => handleArchive(item.id, item.survey_title)}>
                                            <ArchiveRestore size={16} />
                                            <span>Archive</span>
                                        </button>
                                </div>
                                </div>
                            )}
                            </div>   

                        </div>
                    </div>  

                    <div className="col-12 mt-20 border-top pt20px">                    
                        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-md-center gap-3">                        

                            <div className="d-flex w-100 align-items-center"> 
                                
                                <div className="flex-fill border-end px-2 px-sm-3">                        
                                    <div className="fw-bold ft-16 graytext">{item.responses || 0}</div>
                                    <div className="ft-12 color858c95" style={{ whiteSpace: "nowrap" }}>Responses</div>
                                </div>
                            
                                <div className="flex-fill border-end px-2 px-sm-3">                        
                                    <div className="fw-bold ft-16 graytext">{item.completion_rate || "0%"}</div>
                                    <div className="ft-12 color858c95" style={{ whiteSpace: "nowrap" }}>Completion Rate</div>
                                </div>
                            
                                <div className="flex-fill border-end px-2 px-sm-3">                        
                                    <div className="fw-bold ft-16 graytext">{item.view_count ?? item.views ?? 0}</div>
                                    <div className="ft-12 color858c95" style={{ whiteSpace: "nowrap" }}>Views</div>
                                </div>                            
                                {(() => {
                                  const surveyLikesCount = item.like_count ?? item.likes_count ?? 0;
                                  const surveyCommentsCount = item.comment_count ?? item.comments_count ?? 0;
                                  return (
                                    <>
                                
                                <div className="flex-fill border-end px-2 px-sm-3">                        
                                    <div className="d-flex align-items-center gap-2">
                                        <ThumbsUp size={16} className="text-secondary" style={{ flexShrink: 0 }} />
                                        <span className="fw-bold ft-16 graytext">{surveyLikesCount}</span>
                                    </div>
                                    <div className="ft-12 color858c95" style={{ whiteSpace: "nowrap" }}>Likes</div>
                                </div>                            

                                <div 
                                    className="flex-fill px-2 px-sm-3 sr-interactive-stats-col"
                                    onClick={() => {
                                      setSelectedSurvey(item);
                                      toggleComments(item.id);
                                    }}
                                >                        
                                    <div className="d-flex align-items-center gap-2">
                                        <MessageSquare size={16} className="text-secondary" style={{ flexShrink: 0 }} />
                                        <span className="fw-bold ft-16 graytext">{surveyCommentsCount}</span>
                                    </div>
                                    <div className="ft-12 color858c95" style={{ whiteSpace: "nowrap" }}>Comments</div>
                                </div>                            
                                    </>
                                  );
                                })()}
                            </div>  
                        
                            <div className="d-flex justify-content-center justify-content-sm-end w-100 w-sm-auto">
                                <RedButton
                                  btntext="View Responses"
                                  name="viewProfile"
                                  to={`/survey-results/${item.id}`}
                                  state={{ survey: item, tab: "responses" }}
                                />
                            </div>

                        </div>  
                    </div> 

                    {/* Live Comments Drawer Section */}
                    {expandedComments[item.id] && (
                      <div className="col-12">
                        <MySurveyCommentsThread
                          surveyId={item.id}
                          onViewAll={() => {
                            setEngagementModalTab("comments");
                            setSelectedSurvey(item);
                            setShowEngagementModal(true);
                          }}
                        />
                      </div>
                    )}
                </div> 
            </div>
        ))}

        {showCloseSurveyModal && (
            <div className="custom-modal-overlay">

                <div className="tw-w-full tw-max-w-[560px] bg-white rounded-4 p-5 position-relative">

                    <button
                        className="position-absolute top-0 end-0 border-0 bg-transparent p-3"
                        onClick={() => setShowCloseSurveyModal(false)}
                    >
                        <X size={22} />
                    </button>

                    <h4 className="fw-semibold ft-20 mb-4">
                        Close Survey
                    </h4>

                    {/* Warning */}
                    <div className="rounded-3 p-3 mb-24" style={{background:"rgba(255, 247, 238, 1)"}}>

                        <div className="d-flex gap-3">

                            <div className="tw-bg-[#FFF0E4] tw-w-[40px] tw-h-[40px] tw-min-w-[40px] tw-min-h-[40px] tw-rounded-full tw-flex tw-items-center tw-justify-center">
                              <LockKeyhole size={22} className="tw-text-[#EEA23E]" />
                            </div>

                            <div>

                                <h6 className="ft-15 fw-semibold mb-2">
                                    Are you sure you want to close this survey?
                                </h6>

                                <p className="ft-14 fw-400 mb-0 text-secondary">
                                    This action will stop collecting responses.
                                    You won't be able to make it active again.
                                </p>

                            </div>

                        </div>

                    </div>

                    {/* Survey Details */}

                    <div className="rounded-3 p-4 mb-24" style={{background:"rgba(249, 244, 244, 1)"}}>

                        <h6 className="ft-16 fw-semibold textred mb-3">
                            Survey Details
                        </h6>

                        <div className="d-flex justify-content-between mb-4">
                            <div className="d-flex gap-3 align-items-center" style={{color:"#525d6a"}}>
                                <FileText size={18} />
                                        <span className="ft-14 fw-500">Survey Name</span>
                            </div>
                            <span className="ft-14 fw-semibold">{selectedSurvey?.survey_title || ""}</span>
                        </div>

                        <div className="d-flex justify-content-between mb-4">
                            <div className="d-flex gap-3 align-items-center" style={{color:"#525d6a"}}>
                                <Calendar size={18} />
                                <span className="ft-14 fw-500">Created On</span>
                            </div>
                            <span className="ft-14 fw-semibold">{formatDate(selectedSurvey?.created_on)}</span>
                        </div>

                        <div className="d-flex justify-content-between mb-4">
                            <div className="d-flex gap-3 align-items-center" style={{color:"#525d6a"}}>
                                <UsersRound size={18} />
                                <span className="ft-14 fw-500">Total Responses</span>
                            </div>
                            <span className="ft-14 fw-semibold">{selectedSurvey?.responses ?? 0}</span>
                        </div>

                        <div className="d-flex justify-content-between">
                            <div className="d-flex gap-3 align-items-center" style={{color:"#525d6a"}}>
                                <ChartColumnIncreasing size={18} />
                                <span className="ft-14 fw-500">Completion Rate</span>
                            </div>
                            <span className="ft-14 fw-semibold">{selectedSurvey?.completion_rate || "82%"}</span>
                        </div>

                    </div>

                    {/* Bottom Warning */}

                    <div className="rounded-3 p-3 mb-4" style={{background:"rgba(253, 248, 237, 1)"}}>

                        <div className="d-flex gap-4">

                            <TriangleAlert
                                size={22}
                                className="text-warning flex-shrink-0 mt-1"
                            />

                            <div className="ft-14 fw-400 graytext">
                                Closing this survey will move it to Closed Surveys.
                                <br />
                                You can still view the reports and analytics.
                            </div>

                        </div>

                    </div>

                    <div className="d-flex justify-content-end gap-3">

                        <button
                            className="redhoverbtn tw-w-full tw-max-w-[120px] ft-14 fw-bold text-black px-5 py-3 bgwhite rounded-2 cursor-target text-center border border-1 tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-scale-105"
                            onClick={() => setShowCloseSurveyModal(false)}
                        >
                            Cancel
                        </button>

                        <button
                            className="w-33 fw-bold ft-14 text-white px-5 py-3 bgred rounded-2 cursor-target text-center hover:tw-bg-[#333] tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-scale-105"
                            onClick={handleCloseSurvey}
                            disabled={submitting}
                        >
                            {submitting ? "Closing..." : "Yes, Close Survey"}
                        </button>

                    </div>

                </div>

            </div>
        )}

        {showShareModal && (
            <div className="custom-modal-overlay">

                <div className="tw-w-full tw-max-w-[480px] bg-white rounded-4 p-5 position-relative">

                    {/* Close */}

                    <button
                        className="position-absolute top-0 end-0 border-0 bg-transparent p-3"
                        onClick={() => setShowShareModal(false)}
                    >
                        <X size={22} />
                    </button>

                    <h4 className="fw-semibold ft-20 mb-4">
                        Share Survey
                    </h4>

                    {/* Survey */}
                    <div className="rounded-3 p-3 mb-24 tw-bg-[#ECFDF3]">

                        <div className="d-flex gap-3">                        

                            <div className="d-flex flex-column align-items-center">
                                <div className="social-btn whatsapp">
                                    <Share2 size={28} color="#fff" />
                                </div>
                            </div>

                            <div>

                                <h6 className="ft-15 fw-semibold mb-2">
                                {selectedSurvey?.survey_title || "-"}
                                </h6>

                                <p className="ft-14 fw-400 mb-0">
                                Share this survey with your network and get more responses.
                                </p>

                            </div>

                        </div>

                    </div>

                    {/* Link */}
                    <p className="fw-semibold ft-14 mb-2">
                        Share Link
                    </p>

                    <div className="d-flex gap-4 mb-20 tw-p-[12px] border rounded-3 overflow-hidden justify-content-between">

                        <div className="d-flex align-items-center gap-3 w-75">
                            <Link2Icon size={22} />
                            <input type="text" className="form-control p-0 m-0 border-0 shadow-none ft-14 fw-400" value={selectedSurvey?.id ? `https://industrypeople.com/survey/${selectedSurvey.id}...` : "-"} readOnly
                            />
                        </div>

                        <button
                        className="redhoverbtn tw-w-full tw-max-w-[70px] ft-14 fw-bold text-black px-2 py-2 bgwhite rounded-3 cursor-target text-center tw-border tw-border-[#2EBF43] tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-scale-105"
                        onClick={handleCopyLink}
                        >
                        Copy
                        </button>

                    </div>


                    {/* Share  #f6f6f6 */}
                    <div className="rounded-3 p-4 mb-24 tw-bg-[#f6f6f6]">
                
                        <p className="fw-semibold ft-14 mb-4">
                            Share Via
                        </p>

                        <div className="d-flex justify-content-around gap-4">

                            {/* WhatsApp */}
                            <div className="d-flex flex-column align-items-center gap-3 cursor-pointer">
                                <button className="social-btn whatsapp">
                                    <FaWhatsapp size={28} color="#fff" />
                                </button>
                                <span className="ft-12 fw-400 graytext">WhatsApp</span>
                            </div>

                            {/* Facebook */}
                            <div className="d-flex flex-column align-items-center gap-3 cursor-pointer">
                                <button className="social-btn facebook">
                                    <FaFacebookF size={24} color="#fff" />
                                </button>
                                <span className="ft-12 fw-400 graytext">Facebook</span>
                            </div>

                            {/* LinkedIn */}
                            <div className="d-flex flex-column align-items-center gap-3 cursor-pointer">
                                <button className="social-btn linkedin">
                                    <FaLinkedinIn size={24} color="#fff" />
                                </button>
                                <span className="ft-12 fw-400 graytext">LinkedIn</span>
                            </div>

                            {/* X */}
                            <div className="d-flex flex-column align-items-center gap-3 cursor-pointer">
                                <button className="social-btn twitter">
                                    <FaXTwitter size={24} color="#fff" />
                                </button>
                                <span className="ft-12 fw-400 graytext">X (Twitter)</span>
                            </div>

                            {/* Email */}
                            <div className="d-flex flex-column align-items-center gap-3 cursor-pointer">
                                <button className="social-btn email">
                                    <MdOutlineMail size={28} color="#4B5563" />
                                </button>
                                <span className="ft-12 fw-400 graytext">Email</span>
                            </div>

                        </div>
                    </div>

                    <div className="text-end">

                        <button
                        className="redhoverbtn tw-w-full tw-max-w-[120px] ft-14 fw-bold text-black px-5 py-3 bgwhite rounded-2 cursor-target text-center border border-1 tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-scale-105"
                        onClick={() => setShowShareModal(false)}
                        >
                        Close
                        </button>

                    </div>

                </div>

            </div>
            )}

        {showEngagementModal && (
            <MySurveyEngagementModal
                surveyId={selectedSurvey?.id}
                activeTab={engagementModalTab}
                onTabChange={setEngagementModalTab}
                onClose={() => setShowEngagementModal(false)}
            />
        )}



        {hasMore && (
            <div className="d-flex justify-content-center my-4">
                <button
                    className="redhoverbtn px-4 py-2 bgwhite rounded-2 border border-1"
                    onClick={onLoadMore}
                    disabled={loading}
                >
                    {loading ? "Loading..." : "Load More"}
                </button>
            </div>
        )}
              
        </>
    );
};

export default ActiveSurveys;
